import EventEmitter from "./EventEmitter";
import placeholder from "./../static/images/placeholder.jpg";

export default class AssetInfoBox extends EventEmitter {
  constructor() {
    super();
    this.container = document.querySelector(".asset-info-wrapper");
    this.box = document.querySelector(".asset-info");
    this.content = {
      title: this.container.querySelector("#title"),
      partner: this.container.querySelector("#partner"),
      author: this.container.querySelector("#author"),
      img: this.container.querySelector("img"),
      assetid: "",
    };
    this.closeBtn = this.container.querySelector("#close");
    this.gacBtn = this.container.querySelector("#viewgac");
    this.container.addEventListener("click", () => {
      this.hide();
    });
    this.box.addEventListener("click", (e) => {
      e.stopImmediatePropagation();
    });
    this.closeBtn.addEventListener("click", () => {
      this.hide();
    });
    this.gacBtn.addEventListener("click", (e) => {
      this.openAsset(e);
    });
  }
  populate(data) {
    this.content.title.innerText = data.title;
    this.content.author.innerText = data.author;
    this.content.partner.innerText = data.partner;
    this.content.img.src = data.src;
    this.assetid = data.assetid;
    this.content.img.onload = () => {
      this.container.classList.remove("empty");
      this.content.img.style.objectFit = "contain";
    };
  }

  show() {
    this.container.classList.remove("hidden");
    this.box.classList.remove("bounceOutDown");
    this.box.classList.add("bounceInUp");
  }

  hide() {
    this.box.classList.remove("bounceInUp");
    this.box.classList.add("bounceOutDown");

    window.setTimeout(() => {
      this.container.classList.add("hidden");
      this.container.classList.add("empty");
      this.content.img.onload = null;
      this.content.img.src = placeholder;
      this.content.img.style.objectFit = "cover";
    }, 700);
  }

  openAsset(e) {
    e.stopImmediatePropagation();
    this.raiseEvent("visit_asset", [this.assetid]);
  }
}
